/* #region header */
/**************************************************************************************************
//
//  Description:  Wrapper for the history
//
//  Copyright:    © 2021 Aligned Assets Limited
//
//--------------------------------------------------------------------------------------------------
//
//  Modification History:
//
//  Version Date     Modifier            Issue# Description
//#region Version 1.0.0.0 changes
//    001   24.03.21 Sean Flook                 Initial version.
//#endregion Version 1.0.0.0 changes
//
//--------------------------------------------------------------------------------------------------
//#endregion header */

/* #region imports */
import { createBrowserHistory } from "history";
/* #endregion imports */

export default createBrowserHistory();
